import { Box, InputBase, useTheme } from "@mui/material"
import { useEffect, useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";
import { useAddCostMutation } from "../../../newapi/financial/costSlice";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../utils/toasts";
import * as yup from "yup";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import ShValidatedInputDropdown from "../../theme/dropdowns/ShValidatedInputDropdown";
import { yupRequired, yupNumberRequired } from "../../../utils/validation";
import { useGetEnumsQuery } from "../../../newapi/global/generalApiSlice";
import { useGetInvoiceProductsSelectQuery } from "../../../newapi/financial/invoiceProductSlice";
import NumberInput from "../../theme/inputs/NumberInput";
import EMGeneralExplainerBox from "../ModalsPopover/explainers/EMGeneralExplainerBox";
import { useGetRelationsSelectQuery } from "../../../newapi/global/relation/relationSlice";
import { useGetInvoiceCategorySelectQuery } from "../../../newapi/financial/invoiceCategorySlice";
import { InputDropdown } from "../../theme/dropdowns/InputDropdown";


const MAddCost = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [costDataInfo, setCostDataInfo] = useState({
        name: "",
        type: "",
        invoiceType: "",
        invoiceProductId: 0
    });

    const { data: globalEnums, enumIsLoading } = useGetEnumsQuery("cost_type,cost_invoice_type");
    const { data: invoiceProducts, invoiceProductsIsLoading } = useGetInvoiceProductsSelectQuery();
        
    const { data: relationsData, isLoading: relationsLoading } = useGetRelationsSelectQuery();
    const { data: invoiceCategories, isLoading: categoriesLoading } = useGetInvoiceCategorySelectQuery();

    const [types, setTypes] = useState([]);
    const [invoiceTypes, setInvoiceTypes] = useState([]);

    useEffect(() => {
        setInvoiceTypes(globalEnums ? globalEnums["cost.invoice.type"] : []);
    },[globalEnums]);

    useEffect(() => {
        if (globalEnums && costDataInfo) {
            if (costDataInfo?.type === "pickandpack") {
                setInvoiceTypes(globalEnums["cost.invoice.type"].filter(item => item !== "unit"));
            } else if (["storage_pallet", "storage_product", "return", "return_manual", "barcode", "finalize_invoice", "return_shipment", "inbound_manual", "adjustment_charges"].includes(costDataInfo?.type)) {
                setInvoiceTypes(globalEnums["cost.invoice.type"].filter(item => item === "unit"));
            } else if (["surcharges"].includes(costDataInfo?.type)) {
                setInvoiceTypes(globalEnums["cost.invoice.type"].filter(item => ["order", "shipment"].includes(item)));
            } else if (["addonpickandpack"].includes(costDataInfo?.type)) {
                setInvoiceTypes(globalEnums["cost.invoice.type"].filter(item => ["order", "product"].includes(item)));
            }  else if (["inbound_processing"].includes(costDataInfo?.type)) {
                setInvoiceTypes(globalEnums["cost.invoice.type"].filter(item => ["order", "order_line", "order_line_tier", "product", "product_tier"].includes(item)));
            } else {
                setInvoiceTypes(globalEnums["cost.invoice.type"]);
            }
        }
    },[costDataInfo?.type, globalEnums]);

    useEffect(() => {
        setTypes(globalEnums ? globalEnums["cost.type"].filter(item => item !== "shipment") : []);
    },[globalEnums]);

    useEffect(() => {
        if (globalEnums && costDataInfo) {
            if (costDataInfo?.type === "shipment") {
                setTypes(globalEnums["cost.type"].filter(item => item === "shipment"));
            } else {
                setTypes(globalEnums["cost.type"].filter(item => item !== "shipment"));
            }
        }
    },[costDataInfo?.type, globalEnums]);

    useEffect(() => {
        if (props.open) {
            // A caller that knows what the cost is for hands its type in through `preset`.
            setCostDataInfo({
                name: "",
                type: props.preset?.type ?? "",
                invoiceType: "",
                invoiceProductId: null
            });
        }
    }, [props.open, props.preset?.type]);

    const [fieldErrors, setFieldErrors] = useState({});

    const rules = {
        name: yupRequired('name', t),
        type: yupRequired('type', t),
        invoiceType: yupRequired('invoice_type', t),
        ...(["storage_pallet", "storage_product", "return"].includes(costDataInfo?.type) && {
            invoiceProductId: yupNumberRequired('invoice_product', t)
        })
    };
    
    const schema = yup.object().shape(rules);

    const [addCost,{isLoading}] = useAddCostMutation();

    const handleClose = () => {
        setCostDataInfo({
            name: "",
            type: "",
            invoiceType: "",
            invoiceProductId: null
        });

        props.handleClose();
    }
    const SaveCost = async () => {
        try {
            if (isLoading) return;
            setFieldErrors({});
            await schema.validate(costDataInfo, { abortEarly: false });
            const data = await addCost(costDataInfo).unwrap()
            showToastMessagePostRequest(t, data);

            handleClose();
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                  ...acc,
                  [currentError.path]: currentError.message
                }), {});
          
                // Set the validation errors in the state
                setFieldErrors(errors);
              } else {
                // Handle other errors, such as network errors
                showToastMessageRequestError(t("create_failed"), t, err);
              }
        }
    };
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleChange = (key, value) => {
        setCostDataInfo(prev => ({
          ...prev,
          [key]: value
        }));
        setFieldErrors({
            ...fieldErrors,
            [key]: ''
          });
      };

    const labelWidth = 120;

    return(
        <SHModal
            open={props.open}
            onClose={handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("new_cost")}</Subheading>
                {/* <Text light>The data presented will automatically be filtered through the selected warehouses</Text> */}
            </Box>

            {/* BODY */}
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                

                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:labelWidth,
                            flexShrink:0,
                        }}
                    >
                        <Text light>{t("name")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            borderRadius:4,
                            display:"flex",
                        }}
                    >
                        <ShValidatedInput
                            height={40}
                            name="name"
                            value={costDataInfo?.name}
                            onChange={handleChange}
                            error={fieldErrors.name}
                        />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >


                    <Box
                        sx={{
                            width:labelWidth,
                            flexShrink:0,
                        }}
                    >
                        <Text light>{t("type")}</Text>
                    </Box>
                    <ShValidatedInputDropdown
                        disabled={["shipment"].includes(costDataInfo?.type)}
                        name="type"
                        displayName="displayName"
                        changeField="name"
                        selected={types.findIndex(item => item === costDataInfo?.type) ?? -1}
                        options={types.map((item, index) => ({ id: index, name: item, displayName: t(item) }))}
                        noSelection={t("choose_option")} 
                        onChange={handleChange}
                        error={fieldErrors.type}
                    />
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:labelWidth,
                            flexShrink:0,
                        }}
                    >
                        <Text light>{t("invoice_type")}</Text>
                    </Box>
                    <ShValidatedInputDropdown
                        disabled={["shipment"].includes(costDataInfo?.type)}
                        name="invoiceType"
                        displayName="displayName"
                        changeField="name"
                        selected={invoiceTypes.findIndex(item => item === costDataInfo?.invoiceType) ?? -1}
                        options={invoiceTypes.map((item, index) => ({ id: index, name: item, displayName: t(`invoice_type_${item}`) }))}
                        noSelection={t("choose_option")} 
                        onChange={handleChange}
                        error={fieldErrors.invoiceType}
                    />
                </Box>
                {["product_tier", "order_line_tier",].includes(costDataInfo?.invoiceType) && (
                    <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:labelWidth,
                            flexShrink:0,
                        }}
                    >
                        <Text light>{costDataInfo?.invoiceType === "product_tier" ? t("minimum_amount_of_products") : t("minimum_amount_of_lines")}</Text>
                    </Box>
                    <NumberInput btnSize={"24"}
                        value={costDataInfo?.minimumAmountOfProducts}
                    change={(e) => handleChange('minimumAmountOfProducts', e)}/>
                </Box>
                )}
                {["product_tier", "order_line_tier",].includes(costDataInfo?.invoiceType) && (
                    <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:labelWidth,
                            flexShrink:0,
                            display: "flex",
                            alignItems: "center"
                        }}
                    >
                        <Text light>{costDataInfo?.invoiceType === "product_tier" ? t("max_amount_of_products") : t("max_amount_of_lines")}</Text>
                        <EMGeneralExplainerBox title={t('em_cost_maxamount_title')} text={t('em_cost_maxamount_text')}/>
                    </Box>
                    <NumberInput btnSize={"24"}
                        value={costDataInfo?.maximumAmountOfProducts}
                    change={(e) => handleChange('maximumAmountOfProducts', e)}/>
                </Box>
                )}
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:labelWidth,
                            flexShrink:0,
                        }}
                    >
                        <Text light>{t("invoice_product")}</Text>
                    </Box>
                    <ShValidatedInputDropdown
                        disabled={['shipment', 'surcharges', 'pickandpack', 'addonpickandpack'].includes(costDataInfo?.type)}
                        name="invoiceProductId"
                        displayName="name"
                        changeField="id"
                        selected={invoiceProducts ? invoiceProducts.findIndex(item => item.id === costDataInfo?.invoiceProductId) ?? -1 : -1}
                        options={invoiceProducts ?? []}
                        noSelection={t("choose_option")} 
                        onChange={handleChange}
                        error={fieldErrors.invoiceProductId}
                        closeOnSelection
                        searchOptions={{
                            enabled: true,
                            placeholder: t("search_invoice_product_placeholder")
                        }}
                        styles={{
                            minWidth:300
                        }}
                        disallowDeselection
                    />
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:labelWidth,
                            flexShrink:0,
                        }}
                    >
                        <Text light>{t("invoice_categories")}</Text>
                    </Box>
                        <InputDropdown
                            closeOnSelection={false}
                            disabled={!['finalize_invoice'].includes(costDataInfo?.type)}
                            name="invoiceCategories"
                            displayName="name"
                            changeField="id"
                            valueKey="id"
                            multiple
                            selected={costDataInfo?.invoiceCategories ?? []}
                            options={invoiceCategories ?? []}
                            noSelection={t("choose_invoice_category")} 
                            onChange={(val) => handleChange("invoiceCategories",val)}
                            searchOptions={{
                                enabled: true,
                                placeholder: t("search_invoice_category_placeholder")
                            }}
                            styles={{
                                minWidth:300
                            }}
                            disallowDeselection
                        />
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:labelWidth,
                            flexShrink:0,
                        }}
                    >
                        <Text light>{t("relations")}</Text>
                    </Box>
                        <InputDropdown
                            closeOnSelection={false}
                            disabled={!['finalize_invoice'].includes(costDataInfo?.type)}
                            name="relations"
                            displayName="name"
                            changeField="id"
                            valueKey="id"
                            multiple
                            selected={costDataInfo?.relations ?? []}
                            options={relationsData ?? []}
                            noSelection={t("choose_relation")} 
                            onChange={(val) => handleChange("relations",val)}
                            searchOptions={{
                                enabled: true,
                                placeholder: t("search_relation_placeholder")
                            }}
                            styles={{
                                minWidth:300
                            }}
                            disallowDeselection
                        />
                </Box>
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton isLoading={isLoading} className={"group-btn"} color={"green"}
                    variant="contained" 
                    onClick={() => SaveCost()}
                    >{t("add")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MAddCost;
